module.exports = __webpack_public_path__ + "img/Israel.98200797.png";